import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Button, Modal, Row, Col, FormGroup, FormControl } from 'react-bootstrap'
import ColorPicker from '../ColorPicker'
import CopyableTextBlock from '../CopyableTextBlock'

export default class SignInButton extends Component {
  state = {
    showModal: false,
    text: "Sign In",
    foregroundColor: this.props.contrastColor,
    backgroundColor: this.props.primaryColor,
    style: "basicLink"
  }

  static propTypes = {
    type: PropTypes.string.isRequired,
    signinUrl: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    contrastColor: PropTypes.string.isRequired
  }

  showModal = () => {
    this.setState({showModal: true})
  }

  hideModal = () => {
    this.setState({showModal: false})
  }

  renderPreview() {
    const { signinUrl } = this.props
    const { style, text, backgroundColor, foregroundColor } = this.state

    switch(style) {
      case "basicLink":
        return (
          <div>
            { signinUrl }
          </div>
        )
      case "customizedLink":
        return (
          <div>
            <a href={signinUrl} target="_top">{ text }</a>
          </div>
        )
      case "button":
        const buttonStyle = {
          color: foregroundColor,
          display: "inline-block",
          margin: 0,
          fontWeight: "normal",
          cursor: "pointer",
          border: `1px solid ${backgroundColor}`,
          textDecoration: "none !important",
          background: backgroundColor,
          whiteSpace: "nowrap",
          padding: "6px 12px",
          fontSize: "14px",
          lineHeight: "18px",
          borderRadius: 0
        }
        return (
          <div>
            <a href={signinUrl} style={buttonStyle} target="_top">{ text }</a>
          </div>
        )
      default:
        return null;
    }
  }

  get html() {
    const { signinUrl } = this.props
    const { style, text, backgroundColor, foregroundColor } = this.state

    switch(style) {
      case "basicLink":
        return signinUrl
      case "customizedLink":
        return `<a href="${signinUrl}" target="_top">${text}</a>`
      case "button":
        const buttonStyle = `color: ${foregroundColor}; display: inline-block; margin: 0; font-weight: normal; cursor: pointer, border: 1px solid ${backgroundColor}; text-decoration: none !important; background: ${backgroundColor}; white-space: nowrap; padding: 6px 12px; font-size: 14px; line-height: 18px; border-radius: 0`
        return `<a href="${signinUrl}" style="${buttonStyle}" target="_top">${text}</a>`
      default:
        return null;
    }
  }

  render() {
    const { type, signinUrl } = this.props
    const { showModal, style, text, backgroundColor, foregroundColor } = this.state

    return (
      <div>
        <Button onClick={this.showModal} variant="primary">
          <i className="fa fa-code" />
          { " " }
          Get Embed Code
        </Button>
        <Modal show={showModal} onHide={this.hideModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Customize Sign In Link</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={4}>
                <h3>Customize</h3>
                <FormGroup>
                  <Form.Label>Choose Style</Form.Label>
                  <Form.Check
                    type="radio"
                    name="style"
                    checked={style === "basicLink"}
                    onChange={() => this.setState({style: "basicLink"})}
                    label="Link Only"
                    id="customize-sign-in-link-only"
                  />
                  <Form.Check
                    type="radio"
                    name="style"
                    checked={style === "customizedLink"}
                    onChange={() => this.setState({style: "customizedLink"})}
                    label="Customized Link"
                    id="customize-sign-in-customized-link"
                  />
                  <Form.Check
                    type="radio"
                    name="style"
                    checked={style === "button"}
                    onChange={() => this.setState({style: "button"})}
                    label="Button"
                    id="customize-sign-in-button"
                  />
                </FormGroup>
                { (style === "customizedLink" || style === "button") &&
                  <FormGroup>
                    <Form.Label>Text</Form.Label>
                    <FormControl
                      type="text"
                      value={text}
                      onChange={(e) => this.setState({text: e.target.value})}
                    />
                  </FormGroup>
                }

                { style === "button" &&
                  <FormGroup>
                    <Form.Label>Button Color</Form.Label>
                    <ColorPicker
                      value={backgroundColor}
                      onChange={backgroundColor => this.setState({backgroundColor})}
                    />
                  </FormGroup>
                }

                { style === "button" &&
                  <FormGroup>
                    <Form.Label>Text Color</Form.Label>
                    <ColorPicker
                      value={foregroundColor}
                      onChange={foregroundColor => this.setState({foregroundColor})}
                    />
                  </FormGroup>
                }
              </Col>
              <Col sm={4}>
                <h3>Preview</h3>

                <div style={styles.previewStyle}>
                  { this.renderPreview() }
                </div>
              </Col>
              <Col sm={4}>
                <h3>HTML</h3>

                <p>Copy and paste the HTML below into your website to add your sign in link.</p>

                <FormGroup>
                  <CopyableTextBlock value={this.html} />
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hideModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

const styles = {
  previewStyle: {
    wordWrap: 'break-word'
  },
  embedStyle: {
    height: 300
  }
}
